import { Outlet } from "react-router-dom";
import { Title } from "react-head";
import ScrollToHeaderTitle from "misc/ScrollToHeaderTitle";
import ErrorLogsTable from "./error-logs/ErrorLogsTable";

const ErrorLogsPage = () => {
  return (
    <>
      <ScrollToHeaderTitle />
      <div className="px-2 md:px-8 dark:md:px-6">
        <Title>ScraperAPI | Error Logs</Title>
        <div className="text-2xl font-semibold py-6">Error Logs</div>
        <ErrorLogsTable mode="full" />
      </div>
      <Outlet />
    </>
  );
};

export default ErrorLogsPage;
